import React, { useState, useCallback, useEffect } from "react";
import {
	SettingToggle,
	Banner,
	Card,
	Badge,
	TextStyle,
	Button,
	Link,
	Modal,
	TextField,
	Tooltip,
} from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings } from "../../actions";
import { Col, Row } from "reactstrap";
import config from "../../config/config";
import {
	DeleteMajor,
	EditMajor,
	EditMinor,
	PlusMinor,
} from "@shopify/polaris-icons";
import Swal from "sweetalert2";
import BannerHeader from "../Dashboard/BannerHeader";
import PlanTable from "../Dashboard/PlanTable";
const Stripe = () => {
	const dispatch = useDispatch();
	const [modalPlan, setModalPlan] = useState(false);
	const [listStripeToken, setlistStripeToken] = useState([]);
	const [idSelected, setidSelected] = useState(0);
	const dataSettings = useSelector((state) => state.dataSettings);
	const handleToggle = useCallback(() => {
		if (dataSettings.plan == "free" && dataSettings.sync_stripe === "0") {
			Swal.fire({
				icon: "warning",
				title: "Need to upgrade Plan!",
				html: "You need to upgrade to plan <b>Basic or higher</b> to use this feature.",
				showCancelButton: true,
				confirmButtonText: "Pick a higher plan",
				showConfirmButton: true,
			}).then((result) => {
				if (result.value) {
					setModalPlan(true);
				}
			});
		} else {
			if (config.role !== "view") {
				let newSyncStripe =
					dataSettings.sync_stripe === "0" ? "1" : "0";
				let params = {
					action: "updateSyncStripe",
					syncStripe: newSyncStripe,
				};
				callApi("get", params, "services.php").then(function (
					response
				) {
					if (response.data.state === 1) {
						let newDataSettings = { ...dataSettings };
						newDataSettings.sync_stripe = newSyncStripe;
						dispatch(actFetchDataSettings(newDataSettings));
					}
				});

				let newDataSettings = { ...dataSettings };
				newDataSettings.sync_stripe = dispatch(
					actFetchDataSettings(newDataSettings)
				);
			}
		}
	}, [dataSettings, dispatch]);

	useEffect(() => {
		let params = {
			action: "getListStripeToken",
		};
		callApi("get", params, "services.php").then(function (response) {
			if (response.data.state === 1) {
				setlistStripeToken(response.data.listStripeToken);
			}
		});
	}, []);

	const LinkStripe =
		"https://docs.synctrack.io/feature-guides/how-to-create-stripe-token-to-integrate-synctrack-with-stripe";
	// "https://help.omegatheme.com/en/article/how-to-create-api-key-to-integrate-synctrack-with-stripe-1hz6n7/";

	const saveStripeAccount = () => {
		let params = {
			action: "saveStripeAccount",
			id: idSelected,
			stripeToken: stripeToken,
		};
		callApi("get", params, "services.php").then(function (response) {
			if (response.data.state === 1) {
				if (parseInt(idSelected) == 0) {
					let newlistStripeToken = [...listStripeToken];
					let stripeNew = {
						id: response.data.insertId,
						shop: config.shop,
						token: response.data.token,
						confirmed: 1,
					};
					newlistStripeToken.push(stripeNew);

					setlistStripeToken(newlistStripeToken);
				} else {
					let index = listStripeToken.findIndex(
						(x) => x.id === idSelected
					);
					let newlistStripeToken = [...listStripeToken];
					newlistStripeToken[index].token = response.data.token;

					setlistStripeToken(newlistStripeToken);
				}
				setModalStatus(false);
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: "Add Stripe token successfully!",
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				});
			} else {
				Swal.fire({
					icon: "warning",
					html: response.data.msg,
					showConfirmButton: true,
				});
			}
		});
	};

	const deleteStripeToken = (id) => {
		let params = {
			action: "deleteStripeToken",
			id: id,
		};
		callApi("get", params, "services.php").then(function (response) {
			if (response.data.state === 1) {
				let index = listStripeToken.findIndex((x) => x.id === id);
				let newlistStripeToken = [...listStripeToken];
				newlistStripeToken.splice(index, 1);

				setlistStripeToken(newlistStripeToken);
				setModalStatus(false);
				Swal.fire({
					icon: "success",
					title: "Successfully",
					text: "Delete Stripe token successfully!",
					showCloseButton: false,
					showConfirmButton: false,
					timer: 3000,
				});
			}
		});
	};
	const addStripeToken = () => {
		if (
			(dataSettings.plan === "free" || dataSettings.plan === "basic") &&
			listStripeToken.length == 1
		) {
			Swal.fire({
				icon: "warning",
				title: "Need to upgrade Plan!",
				html: "You need to upgrade to plan <b>Pro or higher</b> if you want to connect more Stripe accounts",
				showCancelButton: true,
				confirmButtonText: "Pick a higher plan",
				showConfirmButton: true,
			}).then((result) => {
				if (result.value) {
					setModalPlan(true);
				}
			});
		} else {
			setidSelected(0);
			setModalType("add");
			setModalStatus(true);
			setStripeToken("");
		}
	};

	const editStripeToken = (id) => {
		setidSelected(id);
		setModalType("edit");
		setModalStatus(true);
	};

	const confirmDeleteStripeToken = (id) => {
		setidSelected(id);
		Swal.fire({
			icon: "warning",
			title: "Are you sure?",
			text: "Stripe orders paid to this account will not be synced",
			showCancelButton: true,
			showConfirmButton: true,
		}).then((result) => {
			if (result.value) {
				deleteStripeToken(id);
			}
		});
	};

	const changeStripeToken = (value) => {
		setStripeToken(value);
		if (value === "") {
			setStripeTokenErr("Stripe token is required!");
		} else {
			setStripeTokenErr("");
		}
	};
	const [modalStatus, setModalStatus] = useState(false);
	const [stripeToken, setStripeToken] = useState("");
	const [modalType, setModalType] = useState("add");
	const [stripeTokenErr, setStripeTokenErr] = useState("");

	const contentStatus =
		dataSettings.sync_stripe === "1" ? "Turn off sync" : "Turn on sync";
	const textStatus = dataSettings.sync_stripe === "1" ? "On" : "Off";
	return (
		<div style={{ marginTop: "20px" }}>
			<Card sectioned title="Stripe Settings">
				<div className="pl-4 pr-4">
					<Row>
						<SettingToggle
							action={{
								content: contentStatus,
								onAction: handleToggle,
							}}
							enabled={
								dataSettings.sync_stripe === "0" ? false : true
							}
						>
							Sync tracking info to Stripe status:{" "}
							<TextStyle variation="strong">
								{textStatus}
							</TextStyle>
						</SettingToggle>
					</Row>
					{dataSettings.sync_stripe == "1" ? (
						<div>
							<Row>
								{listStripeToken.length > 0 ? (
									<div className=" w-100">
										{listStripeToken.map((value, index) => {
											return (
												<div
													key={index}
													className="mt-4 pl-4 pr-4 pt-3 pb-3 paypal-account-layout"
													style={{
														fontSize: "16px",
														lineHeight: "34px",
													}}
												>
													<Row>
														<Col
															xs="12"
															sm="12"
															md="8"
														>
															<Badge
																progress="complete"
																status={
																	value.confirmed ==
																	"1"
																		? "success"
																		: "critical"
																}
															>
																{value.confirmed ==
																"1"
																	? "Confirmed"
																	: "Invalid Stripe Token"}
															</Badge>
															<p>
																<b>
																	Stripe
																	token:{" "}
																</b>{" "}
																{value.token}
															</p>
														</Col>
														<Col
															xs="12"
															sm="12"
															md="4"
														>
															<div className="float-right mt-4 d-flex">
																<Tooltip content="Edit Stripe Token">
																	<Button
																		onClick={() =>
																			editStripeToken(
																				value.id
																			)
																		}
																		icon={
																			EditMinor
																		}
																	></Button>
																</Tooltip>
																<div className="delete-button ml-2">
																	<Tooltip content="Delete Stripe Token">
																		<Button
																			className=""
																			onClick={() =>
																				confirmDeleteStripeToken(
																					value.id
																				)
																			}
																		>
																			<i className="far fa-trash-alt" />
																		</Button>
																	</Tooltip>
																</div>
															</div>
														</Col>
													</Row>
												</div>
											);
										})}
									</div>
								) : (
									<div className="w-100">
										<div
											className="mt-5"
											style={{
												fontSize: "16px",
												lineHeight: "28px",
											}}
										>
											<b>Step 1:</b> Give us Stripe token
											to start processing Stripe
											integration. This is{" "}
											<Link url={LinkStripe} external>
												the instruction
											</Link>{" "}
											on how to get an Stripe token.
											<br />
											<b>Step 2:</b> Choose{" "}
											<b>"Add Stripe token"</b> and enter
											the token into the text field.
										</div>
									</div>
								)}
							</Row>
							<Row className="mt-4 mt-3 mb-3">
								<Button
									onClick={addStripeToken}
									primary
									icon={PlusMinor}
								>
									Add Stripe Token
								</Button>
							</Row>
							<Row>
								<div className="w-100 m-2 mt-5">
									<BannerHeader />
								</div>
							</Row>
						</div>
					) : null}
					<Row>
						<div className="mt-3">
							<Banner title="Note:" status="info">
								To keep your account secure, we only need some
								minimal permissions for the integration with
								Stripe to be successful. These access rights
								will not be fully paymentable. Therefore, you do
								not need to worry about security
								<br />
								To check if the integration is successful,
								please follow{" "}
								<a
									href="https://docs.synctrack.io/feature-guides/how-to-self-check-if-stripe-integration-works-successfully"
									target="_blank"
								>
									this document
								</a>
							</Banner>
						</div>
					</Row>
				</div>
			</Card>
			<Modal
				open={modalStatus}
				onClose={() => setModalStatus(false)}
				title={
					modalType === "add"
						? "Add Stripe token"
						: "Edit stripe token"
				}
				primaryAction={{
					content: "Save",
					disabled: stripeToken === "" ? true : false,
					onAction: saveStripeAccount,
				}}
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => setModalStatus(false),
					},
				]}
			>
				<Modal.Section>
					<TextField
						label="Stripe token:"
						value={stripeToken}
						onChange={(value) => changeStripeToken(value)}
						error={stripeTokenErr}
						type="text"
					/>
					<div className="mt-3"></div>
					<Link url={LinkStripe} external>
						How to get Stripe token?
					</Link>
				</Modal.Section>
			</Modal>
			<Modal
				large={true}
				open={modalPlan}
				onClose={() => setModalPlan(false)}
				title="Pricing Table"
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => setModalPlan(false),
					},
				]}
			>
				<Modal.Section>
					<PlanTable type="step" />
				</Modal.Section>
			</Modal>
		</div>
	);
};

export default Stripe;
